import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

const KEY = "deliveries";

export type DeliveryStatus = "open" | "closed" | "cancelled";

export interface Delivery {
	docEntry: number;
	docNum: number;
	docDate: string;
	docDueDate: string | null;
	cardCode: string;
	cardName: string;
	numAtCard: string | null;
	docTotal: number;
	docCur: string | null;
	status: DeliveryStatus;
	salesPerson: string | null;
	comments: string | null;
	orders: { id: string; number: string }[];
}

export interface DeliveryListFilters {
	from?: string | undefined;
	to?: string | undefined;
	status?: string | undefined;
	docNo?: string | undefined;
	customer?: string | undefined;
	orderNo?: string | undefined;
	comments?: string | undefined;
	page: number;
	limit: number;
}

export function useDeliveryList(filters: DeliveryListFilters) {
	return useQuery({
		queryKey: [KEY, filters],
		queryFn: () => {
			const params = new URLSearchParams({
				page: String(filters.page),
				limit: String(filters.limit),
			});
			if (filters.from) params.set("from", filters.from);
			if (filters.to) params.set("to", filters.to);
			if (filters.status) params.set("status", filters.status);
			for (const key of ["docNo", "customer", "orderNo", "comments"] as const) {
				const value = filters[key];
				if (value) params.set(key, value);
			}
			return api.get<{ items: Delivery[]; total: number; range: { from: string; to: string } }>(
				`/api/deliveries?${params.toString()}`,
			);
		},
		staleTime: 60 * 1000,
	});
}

export function deliveryDetailUrl(docEntry: number, orderId: string): string {
	return `/api/deliveries/${docEntry}?orderId=${encodeURIComponent(orderId)}`;
}
